import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { ActiveUserComponent } from '../active-user/active-user.component';

@Component({
  selector: 'app-buscador-admin',
  templateUrl: './buscador-admin.component.html',
  styleUrls: ['./buscador-admin.component.scss'],
})
export class BuscadorAdminComponent implements OnInit {
  @Input() rols
  @Input() items
  @Input() showFilter: boolean = true;
  @Input() showItems: boolean = false;
  @Output() emitSearch = new EventEmitter();
  rolId: string = '';
  itemId: number;
  search = '';
  selectedFilter: string = 'Todos';
  selectedItems: string = 'Todos';
  searchIcon: string = './assets/icons/buscador.svg';

  constructor(
    private uiSv: UiServices
  ) { }

  ngOnInit() {
  }
  
  
  async setFilter(ev){
    try{
      const rols = [
        {
          value: 'Todos',
          id: '0'
        },
      ]
      if(this.rols){
        rols.push(...this.rols)
      }
      const { data } = await this.uiSv.showPopover(ActiveUserComponent, {
        show: 'Rol', 
        state: this.selectedFilter,
        showRol: rols  
      }, 'popoverActivo', ev);
      if(data){
        const rolId = this.rols.find(item => item.value === data)?.id || '';
        this.rolId = rolId;
        this.emitSearch.emit({value: this.search, id: this.rolId})
        this.selectedFilter = data;
      }
    }catch(err){
      console.error(err);
    }
  }
  async setItems(ev){
    try{
      const items = [
        {
          value: 'Todos',
          id: null
        },
      ]
      if(this.items){
        items.push(...this.items)
      }
      const { data } = await this.uiSv.showPopover(ActiveUserComponent, {
        show: 'Rol', 
        state: this.selectedItems,
        showRol: items
      }, 'popoverActivo', ev);
      if(data){
        const itemId = this.items.find(item => item.value === data)?.id || '';
        this.itemId = itemId;
        this.emitSearch.emit({ value: this.search, id: this.rolId, items: this.itemId })
        this.selectedItems = data;
      }
    }catch(err){
      console.error(err);
    }
  }
  onSearchChange(ev){
    this.search = ev.detail.value;
    this.emitSearch.emit({value: this.search});
  }
}
